import { addImageColorFinderFlightsToBuilder } from "./entityActions/flights/imageColorFinder"
import { addInfraredFlightsToBuilder } from "./entityActions/flights/infrared"
import { addOrthoFlightsToBuilder } from "./entityActions/flights/ortho"
import { addSatelliteFlightsToBuilder } from "./entityActions/flights/satellite"
import { addPanoramaFlightsToBuilder } from "./entityActions/flights/panorama"
import { addVideoColorFinderFlightsToBuilder } from "./entityActions/flights/videoColorFinder"
import { addVideoFlightsToBuilder } from "./entityActions/flights/video"
import { Builder } from "./sockets"
import { addLinesToBuilder } from "./entityActions/cubes/line"
import { addHotspotsToBuilder } from "./entityActions/cubes/hotspot"
import { addIconsToBuilder } from "./entityActions/cubes/icon"
import { addIconImagesToBuilder } from "./entityActions/images/icon"
import { addPerimetersToBuilder } from "./entityActions/cubes/perimeter"
import { addTextsToBuilder } from "./entityActions/cubes/text"
import { addInfraredImagesToBuilder } from "./entityActions/images/infrared"
import { addOrthoImagesToBuilder } from "./entityActions/images/ortho"
import { addColorFinderImagesToBuilder } from "./entityActions/images/colorFinder"
import { addPanoramaImagesToBuilder } from "./entityActions/images/panorama"
import { addInfraredJobsToBuilder } from "./entityActions/jobs/infrared"
import { addOrthoJobsToBuilder } from "./entityActions/jobs/ortho"
import { addSatelliteJobsToBuilder } from "./entityActions/jobs/satellite"
import { addPDFJobsToBuilder } from "./entityActions/jobs/pdf"
import { addVideoJobsToBuilder } from "./entityActions/jobs/video"
import { addVideoColorFinderJobsToBuilder } from "./entityActions/jobs/videoColorFinder"
import { addPDFRastersToBuilder } from "./entityActions/cubes/pdfRaster"
import { addGroupsToBuilder } from "./entityActions/cubes/groups"
import { addLiveVideoFlightsToBuilder } from "./entityActions/flights/liveVideo"
import { addUserLocationSharesToBuilder } from "./entityActions/flights/userLocationShare"
import { addMergedFlightsToBuilder } from "./entityActions/cubes/mergedFlights"
import { addRulersToBuilder } from "./entityActions/cubes/ruler"
import { addOrthoMasksToBuilder } from "./entityActions/cubes/orthoMask"
import { addMapCommentsToBuilder } from "./entityActions/cubes/comments"

export const buildEntityCases = (builder: Builder) => {
    addInfraredFlightsToBuilder(builder)
    addOrthoFlightsToBuilder(builder)
    addSatelliteFlightsToBuilder(builder)
    addImageColorFinderFlightsToBuilder(builder)
    addVideoColorFinderFlightsToBuilder(builder)
    addVideoFlightsToBuilder(builder)
    addLiveVideoFlightsToBuilder(builder)
    addPanoramaFlightsToBuilder(builder)
    addLinesToBuilder(builder)
    addRulersToBuilder(builder)
    addHotspotsToBuilder(builder)
    addIconsToBuilder(builder)
    addIconImagesToBuilder(builder)
    addPerimetersToBuilder(builder)
    addTextsToBuilder(builder)
    addInfraredImagesToBuilder(builder)
    addOrthoImagesToBuilder(builder)
    addColorFinderImagesToBuilder(builder)
    addPanoramaImagesToBuilder(builder)
    addInfraredJobsToBuilder(builder)
    addOrthoJobsToBuilder(builder)
    addSatelliteJobsToBuilder(builder)
    addPDFJobsToBuilder(builder)
    addVideoJobsToBuilder(builder)
    addVideoColorFinderJobsToBuilder(builder)
    addPDFRastersToBuilder(builder)
    addGroupsToBuilder(builder)
    addMergedFlightsToBuilder(builder)
    addOrthoMasksToBuilder(builder)
    addMapCommentsToBuilder(builder)
    addUserLocationSharesToBuilder(builder)
    return builder
}
